<template>
  <Intro />
  <!-- <Facts /> -->
  <BivalentVaccine />
  <GeneralInformation />
  <!-- <Vaccination /> -->
  <FAQ />
  <ContactUs />
</template>

<script setup lang="ts">
import Intro from "@/components/covid19/Covid19Intro.vue";
import GeneralInformation from "@/components/covid19/GeneralInformation.vue";
import Facts from "@/components/covid19/Facts.vue";
import Vaccination from "@/components/covid19/Vaccination.vue";
import FAQ from "@/components/covid19/FAQ.vue";
import ContactUs from "@/components/shared/footer/ContactUs.vue";

import { computed, onMounted, ref, toRefs } from "vue";

onMounted(async () => {
  //debugger;
  // window.scrollTo(0, 0);
});
</script>

